<template>
  <div class="sub-wrap">
    <div class="page-content-201">
      <div class="step-wrap">
        <template v-for="(item,idx) in stepData" :key="idx">
          <div class="step-item"
               :class="{'active': currentStep == item.step}">
            <div class="circle">{{ item.step }}</div>
            <div class="info">{{ item.name }}</div>
          </div>

          <div class="line" v-if="idx != stepData.length - 1"></div>
        </template>
      </div>

      <div class="main-box">
        <div class="static-form" v-if="currentStep == 2">
          <h3>企业所得税年度纳税申报表填报表单</h3>

          <div class="table-wrap">
            <table class="static-table" border="1" cellspacing="0" cellpadding="0" tabletype="2024033106">
              <thead>
              <tr>
                <th class="title01 v-middle" rowspan="2" width="30%">表单编号</th>
                <th class="title01 v-middle" rowspan="2" width="50%">表单名称</th>
                <th class="title01" width="20%">选择填报情况</th>
              </tr>
              <tr>
                <th class="title01">填报</th>
              </tr>
              </thead>
              <tbody>
              <tr class="tr">
                <td class="cen title01">A000000</td>
                <td class="title01">企业基础信息表</td>
                <td class="cen">
                  <el-checkbox :model-value="true"/>
                </td>
              </tr>
              <tr class="tr">
                <td class="cen title01">A100000</td>
                <td class="title01">企业所得税年度纳税申报主表</td>
                <td class="cen">
                  <el-checkbox :model-value="true"/>
                </td>
              </tr>
              <tr class="tr">
                <td class="cen title01">A101010</td>
                <td class="title01">&nbsp;&nbsp;&nbsp;&nbsp;一般企业收入明细表</td>
                <td class="cen">
                  <el-checkbox :model-value="false"/>
                </td>
              </tr>
              <tr class="tr">
                <td class="cen title01">A101020</td>
                <td class="title01">&nbsp;&nbsp;&nbsp;&nbsp;金融企业收入明细表</td>
                <td class="cen">
                  <el-checkbox :model-value="false"/>
                </td>
              </tr>
              <tr class="tr">
                <td class="cen title01">A102010</td>
                <td class="title01">&nbsp;&nbsp;&nbsp;&nbsp;一般企业成本支出明细表</td>
                <td class="cen">
                  <el-checkbox :model-value="false"/>
                </td>
              </tr>
              <tr class="tr">
                <td class="cen title01">A102020</td>
                <td class="title01">&nbsp;&nbsp;&nbsp;&nbsp;金融企业支出明细表</td>
                <td class="cen">
                  <el-checkbox :model-value="false"/>
                </td>
              </tr>
              <tr class="tr">
                <td class="cen title01">A103000</td>
                <td class="title01">&nbsp;&nbsp;&nbsp;&nbsp;事业单位、民间非营利组织收入、支出明细表</td>
                <td class="cen">
                  <el-checkbox :model-value="false"/>
                </td>
              </tr>
              <tr class="tr">
                <td class="cen title01">A104000</td>
                <td class="title01">&nbsp;&nbsp;&nbsp;&nbsp;期间费用明细表</td>
                <td class="cen">
                  <el-checkbox :model-value="false"/>
                </td>
              </tr>
              <tr class="tr">
                <td class="cen title01">A105000</td>
                <td class="title01">&nbsp;&nbsp;&nbsp;&nbsp;纳税调整项目明细表</td>
                <td class="cen">
                  <el-checkbox :model-value="true"/>
                </td>
              </tr>
              <tr class="tr">
                <td class="cen title01">A105010</td>
                <td class="title01">
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;视同销售和房地产开发企业特定业务纳税调整明细表
                </td>
                <td class="cen">
                  <el-checkbox :model-value="false"/>
                </td>
              </tr>
              <tr class="tr">
                <td class="cen title01">A105020</td>
                <td class="title01">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;未按权责发生制确认收入纳税调整明细表
                </td>
                <td class="cen">
                  <el-checkbox :model-value="false"/>
                </td>
              </tr>
              <tr class="tr">
                <td class="cen title01">A105030</td>
                <td class="title01">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;投资收益纳税调整明细表</td>
                <td class="cen">
                  <el-checkbox :model-value="false"/>
                </td>
              </tr>
              <tr class="tr">
                <td class="cen title01">A105040</td>
                <td class="title01">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;专项用途财政性资金纳税调整明细表
                </td>
                <td class="cen">
                  <el-checkbox :model-value="false"/>
                </td>
              </tr>
              <tr class="tr">
                <td class="cen title01">A105050</td>
                <td class="title01">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;职工薪酬支出及纳税调整明细表</td>
                <td class="cen">
                  <el-checkbox :model-value="true"/>
                </td>
              </tr>
              <tr class="tr">
                <td class="cen title01">A105060</td>
                <td class="title01">
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;广告费和业务宣传费跨年度纳税调整明细表
                </td>
                <td class="cen">
                  <el-checkbox :model-value="true"/>
                </td>
              </tr>
              <tr class="tr">
                <td class="cen title01">A105070</td>
                <td class="title01">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;捐赠支出及纳税调整明细表</td>
                <td class="cen">
                  <el-checkbox :model-value="true"/>
                </td>
              </tr>
              <tr class="tr">
                <td class="cen title01">A105080</td>
                <td class="title01">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;资产折旧、摊销及纳税调整明细表
                </td>
                <td class="cen">
                  <el-checkbox :model-value="true"/>
                </td>
              </tr>
              <tr class="tr">
                <td class="cen title01">A105090</td>
                <td class="title01">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;资产损失税前扣除及纳税调整明细表
                </td>
                <td class="cen">
                  <el-checkbox :model-value="true"/>
                </td>
              </tr>
              <tr class="tr">
                <td class="cen title01">A105100</td>
                <td class="title01">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;企业重组及递延纳税事项纳税调整明细表
                </td>
                <td class="cen">
                  <el-checkbox :model-value="false"/>
                </td>
              </tr>
              <tr class="tr">
                <td class="cen title01">A105110</td>
                <td class="title01">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;政策性搬迁纳税调整明细表</td>
                <td class="cen">
                  <el-checkbox :model-value="false"/>
                </td>
              </tr>
              <tr class="tr">
                <td class="cen title01">A105120</td>
                <td class="title01">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;贷款损失准备金及纳税调整明细表</td>
                <td class="cen">
                  <el-checkbox :model-value="false"/>
                </td>
              </tr>
              <tr class="tr">
                <td class="cen title01">A106000</td>
                <td class="title01">&nbsp;&nbsp;&nbsp;&nbsp;企业所得税弥补亏损明细表</td>
                <td class="cen">
                  <el-checkbox :model-value="true"/>
                </td>
              </tr>
              <!-- <tr class="tr">
                <td class="cen title01">A107010</td>
                <td class="title01">&nbsp;&nbsp;&nbsp;&nbsp;免税、减计收入及加计扣除优惠明细表</td>
                <td class="cen">
                  <el-checkbox :model-value="false"/>
                </td>
              </tr> -->
              <tr class="tr">
                <td class="cen title01">A107011</td>
                <td class="title01">
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;符合条件的居民企业之间的股息、红利等权益性投资收益优惠明细表
                </td>
                <td class="cen">
                  <el-checkbox :model-value="false"/>
                </td>
              </tr>
              <tr class="tr">
                <td class="cen title01">A107012</td>
                <td class="title01">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;研发费用加计扣除优惠明细表</td>
                <td class="cen">
                  <el-checkbox :model-value="false"/>
                </td>
              </tr>
              <tr class="tr">
                <td class="cen title01">A107020</td>
                <td class="title01">&nbsp;&nbsp;&nbsp;&nbsp;所得减免优惠明细表</td>
                <td class="cen">
                  <el-checkbox :model-value="false"/>
                </td>
              </tr>
              <tr class="tr">
                <td class="cen title01">A107030</td>
                <td class="title01">&nbsp;&nbsp;&nbsp;&nbsp;抵扣应纳税所得额明细表</td>
                <td class="cen">
                  <el-checkbox :model-value="false"/>
                </td>
              </tr>
              <!-- <tr class="tr">
                <td class="cen title01">A107040</td>
                <td class="title01">&nbsp;&nbsp;&nbsp;&nbsp;减免所得税优惠明细表</td>
                <td class="cen">
                  <el-checkbox :model-value="false"/>
                </td>
              </tr> -->
              <tr class="tr">
                <td class="cen title01">A107041</td>
                <td class="title01">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;高新技术企业优惠情况及明细表</td>
                <td class="cen">
                  <el-checkbox :model-value="false"/>
                </td>
              </tr>
              <tr class="tr">
                <td class="cen title01">A107042</td>
                <td class="title01">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;软件、集成电路企业优惠情况及明细表
                </td>
                <td class="cen">
                  <el-checkbox :model-value="false"/>
                </td>
              </tr>
              <tr class="tr">
                <td class="cen title01">A107050</td>
                <td class="title01">&nbsp;&nbsp;&nbsp;&nbsp;税额抵免优惠明细表</td>
                <td class="cen">
                  <el-checkbox :model-value="false"/>
                </td>
              </tr>
              <tr class="tr">
                <td class="cen title01">A108000</td>
                <td class="title01">&nbsp;&nbsp;&nbsp;&nbsp;境外所得税收抵免明细表</td>
                <td class="cen">
                  <el-checkbox :model-value="false"/>
                </td>
              </tr>
              <tr class="tr">
                <td class="cen title01">A108010</td>
                <td class="title01">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;境外所得纳税调整后所得明细表</td>
                <td class="cen">
                  <el-checkbox :model-value="false"/>
                </td>
              </tr>
              <tr class="tr">
                <td class="cen title01">A108020</td>
                <td class="title01">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;境外分支机构弥补亏损明细表</td>
                <td class="cen">
                  <el-checkbox :model-value="false"/>
                </td>
              </tr>
              <tr class="tr">
                <td class="cen title01">A108030</td>
                <td class="title01">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;跨年度结转抵免境外所得税明细表</td>
                <td class="cen">
                  <el-checkbox :model-value="false"/>
                </td>
              </tr>
              <tr class="tr">
                <td class="cen title01">A109000</td>
                <td class="title01">&nbsp;&nbsp;&nbsp;&nbsp;跨地区经营汇总纳税企业年度分摊企业所得税明细表</td>
                <td class="cen">
                  <el-checkbox :model-value="false"/>
                </td>
              </tr>
              <tr class="tr">
                <td class="cen title01">A109010</td>
                <td class="title01">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  企业所得税汇总纳税分支机构所得税分配表
                </td>
                <td class="cen">
                  <el-checkbox :model-value="false"/>
                </td>
              </tr>
              <tr class="tr">
                <td class="cen title01">受控外国企业信息报告表</td>
                <td class="title01">&nbsp;&nbsp;&nbsp;&nbsp;受控外国企业信息报告表</td>
                <td class="cen">
                  <el-checkbox :model-value="false"/>
                </td>
              </tr>
              <tr class="tr">
                <td class="cen title01">非货币性资产投资递延纳税调整明细表</td>
                <td class="title01">非货币性资产投资递延纳税调整明细表</td>
                <td class="cen">
                  <el-checkbox :model-value="false"/>
                </td>
              </tr>
              <tr class="tr">
                <td class="cen title01">居民企业资产（股权）划转特殊性税务处理申报表</td>
                <td class="title01">居民企业资产（股权）划转特殊性税务处理申报表</td>
                <td class="cen">
                  <el-checkbox :model-value="false"/>
                </td>
              </tr>
              <tr class="tr">
                <td class="cen title01">海上油气生产设施弃置费情况表</td>
                <td class="title01">海上油气生产设施弃置费情况表</td>
                <td class="cen">
                  <el-checkbox :model-value="false"/>
                </td>
              </tr>
              <tr class="tr">
                <td class="cen title01">中华人民共和国企业政策性搬迁清算损益表</td>
                <td class="title01">中华人民共和国企业政策性搬迁清算损益表</td>
                <td class="cen">
                  <el-checkbox :model-value="false"/>
                </td>
              </tr>
              <tr>
                <td colspan="3" class="title01"
                    style="text-align: center;"
                >说明：企业应当根据实际情况选择需要填表的表单。
                </td>
              </tr>
              </tbody>
            </table>
          </div>

        </div>

        <div
            v-show="currentStep == 1"
            class="opera-area question-out-common">
          <component
              :qaType="activeName"
              :current-qa="currentQa"
              :is="taxQuestionManager5" ref="viewRef"
              @save="tax201Save"
          />
        </div>
      </div>

      <div class="bottom-sep"></div>

      <div class="bottom-box">
        <el-button
            v-if="currentStep == 1"
            type="primary" plain
            @click="getInitialData"
        >获取初始化数据
        </el-button>
        <el-button
            v-if="currentStep > 1"
            type="primary" plain
            @click="toggleStep(-1)"
        >上一步
        </el-button>
        <el-button
            v-if="currentStep <= stepData.length - 1"
            type="primary"
            @click="toggleStep(1)"
        >下一步
        </el-button>
      </div>

    </div>

    <before-exe201-dialog
    />

  </div>
</template>

<script setup lang="jsx">
// 汇算清缴-企业所得税年度申报
import Big from "big.js";
import {ElMessage, ElMessageBox} from "element-plus";
import {$emit, $on} from "vue-happy-bus";
import {reportTaxDateConfig} from "@/views/examCenter/reportTax/reportTaxStaticConfig.js";
import taxQuestionManager5 from "@/views/examCenter/reportTax/taxQuestionManager5/index.vue";
import BeforeExe201Dialog from "./beforeExe201Dialog.vue";

const emit = defineEmits(['startExam', 'finish']);

const props = defineProps({
  currentQa: { // 当前题目信息对象
    required: true,
    type: Object,
  },
})

const {staticConfig} = reportTaxDateConfig(props.currentQa)

// 题目json信息转js对象
const qaData = computed(() => {
  const taxDataAll = props.currentQa?.solution && JSON.parse(props.currentQa.solution) || null
  return taxDataAll == null ? JSON.parse(props.currentQa.answer) : taxDataAll
})

const currentStep = ref(1)
const stepData = [
  {
    name: '基本信息',
    step: 1,
  },
  {
    name: '表单选择',
    step: 2,
  },
  {
    name: '填报报表',
    step: 3,
  },
  {
    name: '提交报表',
    step: 4,
  },
]

const activeName = ref('1')
const viewRef = ref();

onMounted(() => {
  activeName.value = 'tax52'
  nextTick(() => {
    const taxDataAll = props.currentQa?.solution && JSON.parse(props.currentQa.solution) || null
    console.log('报税题onMounted数据', taxDataAll, JSON.parse(props.currentQa.answer))
    viewRef.value.taxInit({
      mode: 1, // 1 做题 2 设置题目 3 查看结果 4 查看答案
      taxDataAll: taxDataAll == null ? JSON.parse(props.currentQa.answer) : taxDataAll, // 只有新建题目不需要传入taxDataAll 修改题目，做题，查看结果都需要传入
    });
  })
})

let step2Flag = ref(false) // 是否为第1步后点击跳转第2步

function toggleStep(by) {
  if (currentStep.value == 1) { // 第一步跳转第2步，需保存数据
    step2Flag.value = true
    $emit('exeSaveQa', {status: 0,})
    return
  }
  step2Flag.value = false
  currentStep.value += by
  if (currentStep.value == 3) {
    emit('startExam')
  }
}

function getInitialData() {

}


/*
 * ！！！提交写数据区
 */

// 组件里面的暂存
const tax201Save = async () => {
  step2Flag.value = false
  $emit('exeSaveQa', {status: 0})
};

// 爷爷组件，保存成功回调
$on('saveQaSuccess', res => {
  const data = JSON.parse(res?.serverData?.solution || "{}")
  if (step2Flag.value) {
    currentStep.value = 2 // 点击201里面的下一步触发的保存成功，跳转到第2步
    step2Flag.value = false
  }
})

const getGrandchildValue = inject('getGrandchildValue');
getGrandchildValue.value.getData = (byUser, params) => {
  if (!Boolean(byUser)) { // 非用户主动保存数据，不触发修改solution。即报税题需用户手动点击保存按钮
    return {}
  }
  let taxDataAll
  if (currentStep.value == 1) {
    taxDataAll = viewRef.value.taxSave(2);
    taxDataAll.status = params.status // 将暂存、提交按钮的参数带入
  } else {
    taxDataAll = {
      ...qaData.value,
      status: params.status, // 将暂存、提交按钮的参数带入
    };
  }
  return {
    solution: JSON.stringify(taxDataAll),
  }
}
</script>

<style scoped lang="scss">
.sub-wrap {
  box-sizing: border-box;
  width: 100%;

  .page-content-201 {
    height: calc(100vh - 100px);
    width: inherit;

    .step-wrap {
      height: 76px;
      display: flex;
      align-items: center;
      justify-content: center;

      .step-item {
        display: flex;
        align-items: center;

        .circle {
          font-weight: 700;
          margin-right: 8px;
          width: 24px;
          height: 24px;
          border: 1px solid rgb(170, 170, 170);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #cccccc;
          font-size: 16px;
        }

        &.active {
          .circle {
            background-color: #4285f4;
            border: 1px solid #4285f4;
          }

          .info {
            font-weight: 700;
            color: #4285f4;
          }
        }
      }

      .line {
        height: 2px;
        width: 80px;
        background-color: #999999;
        margin: 0 8px;
      }
    }

    .main-box {
      height: calc(100% - 48px - 76px - 50px);
      background-color: #F9FAFD;

      .opera-area {
        height: 100%;
      }

      .static-form {
        height: 100%;
        overflow-y: auto;
        > h3 {
          padding-top: 16px;
          padding-bottom: 16px;
          line-height: 36px;
          text-align: center;
          font-size: 24px;
          font-weight: 600;
          color: #333333;
        }

        .table-wrap {
          padding: 16px 24px 0 24px;
          background-color: #FFFFFF;

          .static-table {
            width: 100%;
            font-size: 14px;
            border-color: rgb(220, 220, 220);
            border-spacing: 1px;
            border-collapse: collapse;

            .title01 {
              background-color: #FAFAFA;
              line-height: 20px;
              padding: 10px 16px;
              font-size: 14px;
              box-sizing: border-box;
            }

            td, th {
              border: 1px solid rgb(220, 220, 220);
            }

            th {
              font-weight: bold;
            }

            .cen {
              text-align: center !important;
            }

            .v-middle {
              vertical-align: middle;
            }
          }
        }


      }
    }

    .bottom-sep {
      height: 50px;
      background-color: #F9FAFD;
    }

    .bottom-box {
      height: 48px;
      box-sizing: border-box;
      padding: 8px 0;
      display: flex;
      justify-content: center;
      box-shadow: 0 -2px 5px 0 rgba(6, 13, 97, .102);
    }
  }
}

@import url(../cmp/commonStyle.scss);
</style>
